import SelectModulePanel from './SelectModulePanel';

export default SelectModulePanel;
